/**
 * FadeInContent Component
 * Wrapper component that provides smooth fade-in animation for content
 */

import React from 'react';
import { Animated, ViewStyle } from 'react-native';

interface FadeInContentProps {
  /** Animated opacity value from useSkeletonLoading */
  opacity: Animated.Value;
  /** Children to fade in */
  children: React.ReactNode;
  /** Optional style */
  style?: ViewStyle;
  /** Test ID */
  testID?: string;
}

export const FadeInContent: React.FC<FadeInContentProps> = ({
  opacity,
  children,
  style,
  testID,
}) => {
  return (
    <Animated.View style={[{ opacity }, style]} testID={testID}>
      {children}
    </Animated.View>
  );
};


